import React, { FC } from 'react'

import { getMobileNavEvent, IconLink, TrustIconProps } from '@Components/TrustIcons/common'

export const TrustIconCH: FC<TrustIconProps> = ({ variant }: TrustIconProps) => (
  <IconLink
    analytics={getMobileNavEvent('vsv-versandhandel', variant)}
    href="https://www.vsv-versandhandel.ch/fr/members/detail/trendhim-aps/"
    rel="noopener noreferrer"
    target="_blank"
    variant={variant}
  >
    <img alt="" src="https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt7e60be22df067f31/swiss-online-guarantee-logo.png" />
  </IconLink>
)
